import styled from "styled-components";

const Skeleton2 = ({ height = "40px" }) => {
  return (
    <SkeletonStyle role="status">
      <div
        style={{
          height: height,
        }}
        className="inner"
      ></div>
    </SkeletonStyle>
  );
};

export default Skeleton2;

const SkeletonStyle = styled.div`
  width: 94%;
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  padding: 1.5rem;
  display: flex;
  justify-content: space-around;
  gap: 0.5rem;

  @keyframes pulse {
    50% {
      opacity: 0.2;
    }
  }

  .inner {
    background-color: rgba(0, 0, 0, 0.137);
    border-radius: 0.5rem /* 8px */;
    width: 100%;
    margin-bottom: 1rem /* 16px */;
  }
`;
